var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1757",
    "data-name": "Group 1757",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.151,
    height: 27.996,
    viewBox: "0 0 100.151 27.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2253",
    "data-name": "Rectangle 2253",
    width: 100.151,
    height: 27.996,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5072",
    "data-name": "Path 5072",
    d: "M97.5,5.848A13.969,13.969,0,0,0,86.693.013c-9.843-.428-13.613,9.7-13.613,9.7C70.339,0,62.2.321,61.344.349c-.084,0-8.731,0-8.731,0V23.409L42.185.828h-.734L29.876,24.794,24.9.353,15.04,18.028,5.665.013,0,27.484H4.687L7.377,12.73,15.121,27.4l7.5-14.592,2.771,14.755,8.722-.081,2.853-7.173H46.1l2.853,7.255H60.141a13.887,13.887,0,0,0,5.88-1.257c5.138-2.4,6.529-6.87,7.058-7.466a13.56,13.56,0,0,0,13.287,9.14c6.15-.25,9.625-3.114,11.588-6.208A14.336,14.336,0,0,0,97.5,5.848M39.006,16.072l2.527-6.114,2.69,6.114Zm20.583,7.021a9.123,9.123,0,0,1-1.875-.194V5.1a9.1,9.1,0,1,1,1.875,18m35.787-8.327a9.2,9.2,0,1,1-9.783-9.783,9.238,9.238,0,0,1,9.783,9.783",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMado);
export default __webpack_public_path__ + "static/media/logo-mado.259e84c84a45d46d49980f4a04ae067a.svg";
export { ForwardRef as ReactComponent };